import { GiDeathSkull } from 'react-icons/gi';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Mortes',
        path: '/governanceroom/dashboardsihsus/discharge/death',
        icon: <GiDeathSkull />
    }
];

const titlesMap = {
    '/governanceroom/dashboardsihsus/discharge/death': 'Tipos de Alta (Óbito)'
};

export const Discharge = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsihsus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titlesMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="death"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'dos Tipos de Alta (Óbito)'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.DEATH_TYPE,
                                        url: 'governanceroom/dashboard/sihsus/aih/death'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route
                            path="/"
                            element={<Navigate to="death" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
